import { render, staticRenderFns } from "./FeatureBlock.vue?vue&type=template&id=2383250d&scoped=true"
import script from "./FeatureBlock.vue?vue&type=script&lang=js"
export * from "./FeatureBlock.vue?vue&type=script&lang=js"
import style0 from "./FeatureBlock.vue?vue&type=style&index=0&id=2383250d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2383250d",
  null
  
)

export default component.exports